import { DyteParticipant, DyteSelf } from '@dytesdk/web-core';
import React, { useContext } from 'react';
import UserAvatar from 'react-native-user-avatar';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  participant,
  iconPack = defaultIconPack,
  size = 'sm',
  // ToDo: Implement shape on avatar
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  variant = 'circular',
}: {
  participant: DyteParticipant | DyteSelf;
  iconPack?: IconPack;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  variant?: 'circular' | 'hexagon' | 'square';
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  iconPack = iconPack ?? defaultIconPack;
  // console.log(size);
  let avatarSize = 100;
  switch (size) {
    case 'sm':
      avatarSize = 50;
      break;
    case 'lg':
      avatarSize = 150;
      break;
    case 'xl':
      avatarSize = 200;
      break;
  }
  const renderAvatar = () => {
    return (
      <UserAvatar
        size={avatarSize}
        src={participant.id}
        name={participant.name ?? 'P'}
        bgColor={colors.brand[500]}
        style={{
          height: avatarSize,
          width: avatarSize,
        }}
      />
    );
  };
  return renderAvatar();
}
